import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './contexts/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import RedirectHandler from './components/RedirectHandler';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import SectorsPage from './pages/SectorsPage';
import WorkflowsPage from './pages/WorkflowsPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import LouiseTrinitIAPage from './pages/LouiseTrinitIAPage';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <RedirectHandler />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/secteurs" element={<SectorsPage />} />
            <Route path="/workflows" element={<WorkflowsPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/louise-trinit-ia" element={<LouiseTrinitIAPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
